export default "__VITE_ASSET__7ba75064__"